import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getCompanyDefaultSignature = async (questionId) => {
  return await request.get(
    `/Question/company_default_signature`,
    { questionId },
    ''
  );
};

const useCompanyDefaultSignature = (questionId, options) =>
  useQuery(
    questionsQueryKeys.companyDefaultSignature(questionId),
    () => getCompanyDefaultSignature(questionId),
    options
  );

export default useCompanyDefaultSignature;
